import dayjs from "dayjs";
import {formatCurrency} from "../../../../../format/Money";

class ShiftMapper {

    mapShiftToIntShift(from) {
        if (Object.keys(from).length === 0) {
            return{};
        }
        const format = "H:mm";
        const shiftIntervals = this.shiftIntervals(from);
        const shiftApplyFors = this.shiftApplyFors(from);
        let autoCheckOutApplyPosition = [];
        from.shiftApplyDetails?.map((item) => {
            autoCheckOutApplyPosition.push(item.id)
        })
        let applyForPosition = [];
        from.shiftApplyForPositions?.map((item) => {
            applyForPosition.push(item.id)
        })
        let applyForDepartment = [];
        from.shiftApplyForDepartments?.map((item) => {
            applyForDepartment.push(item.id)
        })
        return ({
            ...from,
            code : from.code ,
            name : from.name ,
            checkInByCount : from.checkInByCount,
            isInterval : from.isInterval,
            timeBetweenCheckIn : from.timeBetweenCheckInMinute !== 0 || from.timeBetweenCheckInHour !== 0  ? dayjs(from.timeBetweenCheckIn,format) : null,
            checkFirstShift: from.checkInBreakTimeStartHour !== 0 || from.checkInBreakTimeStartMinute !== 0  ? dayjs(from.checkInBreakTimeStartString,format) : null,
            checkInFirst: from.checkInBeforeHour !== 0 || from.checkInBeforeMinute !== 0  ? dayjs(from.checkInBeforeString,format) : null,
            checkInLater: from.checkOutBeforeHour !== 0 || from.checkOutBeforeMinute !== 0  ? dayjs(from.checkOutBeforeString,format) : null,
            checkNextShift: from.checkInBreakTimeEndHour !== 0 || from.checkInBreakTimeEndMinute !== 0 ? dayjs(from.checkInBreakTimeEndString,format) : null,
            codeShift: from.codeShift,
            endBreak: from.breakTimeEndHour !== 0 || from.breakTimeEndMinute !== 0  ?  dayjs(from.breakTimeEndString,format) : null, // todo Implement
            flexibleHours: from.flexibleHour !== 0 || from.flexibleMinute !== 0  ? dayjs(from.flexibleString,format) : null,
            noteShift: from.noteShift,
            overTime: from.overTime,
            timeBreak:from.breakTimeStartHour !== 0 || from.breakTimeStartMinute !== 0  ?  dayjs(from.breakTimeStartString,format) : null,
            totalHours: formatCurrency(from.flexibleTotalHour),
            totalWork: formatCurrency(from.totalWork),
            flexibleApplyFor : from.flexibleApplyFor,
            shiftIntervals,
            shiftApplyFors,
            shiftAutoCheckoutPositionIds : autoCheckOutApplyPosition,
            shiftApplyForPositionIds : applyForPosition ,
            shiftApplyForDepartmentIds :applyForDepartment
        })
    }

    shiftIntervals(from) {
        const format = "H:mm";
        return from.shiftIntervals.map((item) => {
            return({
                timeIn : !item.fromTimeString ? "" : dayjs(item.fromTimeString,format),
                timeOut : !item.toTimeString ? "" : dayjs(item.toTimeString,format),
                isOverDay : item.isOverDay
            })
        })
    }

    shiftApplyFors(from) {
        return from.shiftApplyFors.map((item) => {
            return({
                departmentId : !item.department.id ? "" : item.department.id,
                jobPositionId : !item.jobPosition.id ? "" : item.jobPosition.id,
                jobTitleId : !item.jobTitle.id ? "" : item.jobTitle.id
            })
        })
    }

}
export default new ShiftMapper()